import { Link } from "react-router-dom"
import Footer from "../components/footer"

const About = () => {

  const localStorageClear = () => {
    localStorage.clear();
  }

  return (
    <div>
    <div className="top-textarea">
      <div></div>
      <h2>このアプリについて</h2>
      <p>「何ねこ？」は、保護猫シェルター併設カフェ「<a href="https://suama-catscafe.com/" className="a-text-link"  onClick={ localStorageClear }>すあま商會</a>」が運営する、ひとりひとりの猫の個性と向き合うアプリです。</p>
      <p>愛猫さんのことはなんでもわかっている飼い主さん。〈うちの子は穏やかな性格〉〈うちの子は優しい〉〈うちの子は気が強い〉……でも、それってほんとう？<br />
それは、それぞれの猫ちゃんが飼い主さんに見せている姿のほんの一面なのかもしれません。ほかの人間や、ほかの猫、ほかの動物にたいしては、違う姿を見せるかもしれません。<br /></p>
<p>〈ふたりめの猫ちゃんを飼いたいけど、うちの子はなかよくできるかな？〉〈うちの子は温厚だからどんな猫でも受け入れるはず〉そう思ってふたりめの迎えたけれど、思うようにいかなかったという人も、いるかもしれません。〈うちの子は気が小さいから私以外は受け入れない〉と思っていた猫ちゃんが、あんがい、ほかの猫ちゃんをすんなり受け入れ、たくさんお世話をしてくれる、なんてこともあります。<br />
〈うちの子はほんどうはどんな子なのか〉〈ふたりめを迎えたいんだけど、大丈夫かな？〉そんな疑問に、ちょっとだけ寄り添うのが「何ねこ？」です。<br />
もしかしたら診断結果は、思っていた結果とは違うかもしれないし、実際の猫ちゃんの姿とは違うかもしれません。あくまで参考として、ゲーム感覚で楽しんでいただければと思います。<br /></p>
<p>このアプリで猫の「社会性」と「性格」について分析、大枠の結果について監修してくださったのは、動物行動学者の入交眞巳先生です。また、すあま商會と同じ板橋区にある株式会社フェリックスのみなさんが、アプリをつくってくれました。<br />
入交先生、フェリックスのスタッフさん、そしてすあま商會。全員が猫を飼っている猫好きという最強猫好きによる猫好きのためのアプリ「何ねこ？」をお楽しみください。<br /></p>
    </div>
    <div className="btn_assessment_wrapper">
    <Link to="/nanineko/impression"  onClick={ localStorageClear }><button className="btn_assessment"></button></Link>
    </div>
    <Footer />
    </div>
  )
}
  
  export default About